import { HTMLAttributes, forwardRef } from 'react';
import { cn } from './cn';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padding?: 'sm' | 'md' | 'lg' | 'none';
}

const paddingClasses = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-5',
};

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ padding = 'md', className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'rounded-lg border border-nova-border bg-nova-card text-nova-card-foreground shadow-sm',
        paddingClasses[padding],
        className
      )}
      {...props}
    />
  )
);

Card.displayName = 'Card';
